import React, {useState} from 'react'
import OrderModal from 'app/features/orders/componentsv1/view/orderModal/OrderModal'
import EditShippingRate from 'app/features/orders/orderEdit/edit/components/ShippingRateList/EditShippingRate'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from 'setup'
import {
  checkCompliance,
  selectEditOrder,
  selectOrderEditIsSubmitting,
  selectOrderShippingAddress,
  setShippingRate,
} from 'app/features/orders/redux/order/orderEditSlice'
import {Order} from 'app/features/orders/models/EditOrderState'
import AddressAction from '../Address/AddressAction'

interface Props {
  onCloseEditRate: () => void
  onOpenAddress: () => void
  onCustomRateOpen: () => void
}

export const SelectShippingRateDialog: React.FC<Props> = ({
  onCloseEditRate,
  onOpenAddress,
  onCustomRateOpen,
}) => {
  const dispatch = useDispatch()
  const order = useSelector<RootState, Order>(selectEditOrder)
  const shippingAddress = useSelector<RootState, any>(selectOrderShippingAddress)
  const isSubmitting = useSelector<RootState, boolean>(selectOrderEditIsSubmitting)

  const [shippingMethod, setShippingMethod] = useState<any>(null)
  const [shippingMtd, setShippingMtd] = useState<any>(null)

  const handleShippingMethodChange = () => {
    dispatch(setShippingRate({...shippingMtd, id: order.shippingRateId}))
    setShippingMethod({...shippingMtd, id: order.shippingRateId})
    dispatch(checkCompliance())
    onCloseEditRate()
  }

  const handleSetShippingMethod = (shippingMtd: any) => {
    setShippingMethod({...shippingMtd, id: order.shippingRateId})
    setShippingMtd(shippingMtd)
  }

  return (
    <OrderModal
      btnText='Confirm'
      title='Select Shipping Rate'
      onClose={onCloseEditRate}
      icon='delivery-van'
      onConfirm={handleShippingMethodChange}
      disabled={!shippingMethod}
      isSubmitting={isSubmitting}
    >
      <EditShippingRate
        onShippingRateChange={handleSetShippingMethod}
        selectedShippingRate={shippingMethod}
        onCustomRateOpen={onCustomRateOpen}
      >
        <AddressAction
          title='Shipping Address'
          isEditMode
          address={shippingAddress}
          onOpenDialog={onOpenAddress}
        />
        <hr className='mb-5' />
      </EditShippingRate>
    </OrderModal>
  )
}

export default SelectShippingRateDialog
